export default "/_next/static/images/3d52e0a1bb896870aae71b9e146522cc.jpg";